/**
 * React Native Firebase rejects `undefined` in `setDoc` payloads ("Unsupported field value: undefined").
 * Omits undefined object keys and recurses into arrays and plain objects.
 * Leaves class instances (Date, Timestamp, FieldValue, etc.) unchanged.
 */
export function stripUndefinedDeep<T>(value: T): T {
  if (value === undefined) {
    return value;
  }
  if (value === null || typeof value !== 'object') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(stripUndefinedDeep) as T;
  }
  const proto = Object.getPrototypeOf(value);
  if (proto !== null && proto !== Object.prototype) {
    return value;
  }
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
    if (v === undefined) continue;
    out[k] = stripUndefinedDeep(v);
  }
  return out as T;
}
